import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {
    extendedStyles?: SubCategoryDetailsStyles;
}

export interface SubCategoryDetailsStyles {
    widgetGridContainer?: GridContainerProps;
    categoryDetailLinkListGridItem?: GridItemProps;
    subCategoryGridItem?: GridItemProps;
}

export const subCategoryDetailsContainerStyles: SubCategoryDetailsStyles = {
    widgetGridContainer: {
        css: css`
            
        `,
    },
    categoryDetailLinkListGridItem: {
        width: [12, 12, 3, 3, 3],
    },
    subCategoryGridItem: {
        width: [12, 12, 9, 9, 9],
    },
};

const SubCategoryDetailsContainer: FC<OwnProps> = ({ id, extendedStyles }) => {
    const [styles] = React.useState(() => mergeToNew(subCategoryDetailsContainerStyles, extendedStyles));
    return (
        <GridContainer {...styles.widgetGridContainer} date-test-selector="widgetGridContainer">
            <GridItem {...styles.categoryDetailLinkListGridItem}>
                <Zone zoneName="CategoryDetailLinkListGridItem" contentId={id} />
            </GridItem>
            <GridItem {...styles.subCategoryGridItem}>
                <Zone zoneName="SubCategoryGridItem" contentId={id} />
            </GridItem>
        </GridContainer>
    );
};

const subCategoryDetailsContainer: WidgetModule = {
    component: SubCategoryDetailsContainer,
    definition: {
        displayName: "SubCategoryDetails",
        group: "Category Details",
        allowedContexts: ["CategoryDetailsPage"],
    },
};

export default subCategoryDetailsContainer;
